export interface IBottomPositionProps {
  isOpened: boolean;
  isValid: boolean;
  externalButtonHeight: number;
  payButtonWrapperHeight: number;
  concealableWrapperElementHeight: number;
  progressElementHeight: number;
}

export const getShortDescriptionCssBottomPosition = ({
  isOpened,
  isValid,
  externalButtonHeight,
  payButtonWrapperHeight,
  concealableWrapperElementHeight,
  progressElementHeight,
}: IBottomPositionProps) => {
  if (isOpened && isValid) {
    return externalButtonHeight + payButtonWrapperHeight - concealableWrapperElementHeight - progressElementHeight;
  }
  if (isOpened) {
    return externalButtonHeight - concealableWrapperElementHeight - progressElementHeight;
  }
  return progressElementHeight;
};

export const getOrderDescriptionCssBottomPosition = ({
  isOpened,
  isValid,
  externalButtonHeight,
  payButtonWrapperHeight,
  progressElementHeight,
}: IBottomPositionProps) => {
  if (isOpened) {
    return progressElementHeight;
  }
  if (isValid) {
    return -(externalButtonHeight + payButtonWrapperHeight - progressElementHeight);
  }
  return -externalButtonHeight + progressElementHeight;
};
